import styled from 'styled-components';
import { Input } from 'antd';
import { COLORS, DEVICES, pickThemeFontSize, pickThemeFontStyles } from '@/theme';

export const StyledPhoneField = styled(Input)`
  width: 100%;
  height: 2.75rem;
  background: ${COLORS.WHITE};
  color: ${COLORS.BLACK_PRIMARY};
  border: 1px solid ${COLORS.SOFT_GRAY};
  border-radius: 0.375rem;
  ${pickThemeFontStyles('14', '20')};
  :hover {
    border: 1px solid ${COLORS.CHARCOAL};
  }

  &.ant-input-disabled {
    background: ${COLORS.GRAY}!important;
    ${pickThemeFontStyles('14', '20')};
    border: 1px dashed ${COLORS.LIGHT_GRAY};
    color: ${COLORS.NORMAL_GRAY};
  }
  &.ant-input-affix-wrapper {
    overflow: hidden;

    & .ant-input {
      background: ${COLORS.LIGHTEST_GRAY};
      ${pickThemeFontStyles('14', '20')};
    }

    & .ant-input-suffix {
      font-size: ${pickThemeFontSize('20')};
      background: ${COLORS.LIGHTEST_GRAY};
      margin: 0;
    }

    & .ant-input-prefix {
      font-size: ${pickThemeFontSize('20')};
      background: ${COLORS.LIGHTEST_GRAY};
      margin: 0;
    }
  }

  @media screen and ${DEVICES.LAPTOP_S} {
    &.ant-input {
      ${pickThemeFontStyles('14', '22')};
    }

    &.ant-input-affix-wrapper {
      & .ant-input {
        ${pickThemeFontStyles('14', '22')};
      }
    }
  }
`;
